class CTab {
    constructor(place) {
        this.place = place
        this.triggers = place.querySelectorAll('[data-custom-tab-trigger]')
        this.contents = place.querySelectorAll('[data-custom-tab-content]')
        this.startIndex = 0
        if (
            (this.triggers.length === this.contents.length) &&
            (this.triggers.length != 0) &&
            (this.contents.length != 0)
        ) {
            this.init()
        } else {
            setTimeout((e) => {
                customTabsInit()
            }, 500)
        }
    }

    init() {
        for (let i = 0; i < this.contents.length; i++) {
            this.contents[i].style.transition = 'all 0.15s linear'
            this.contents[i].classList.add('opac-0')
            this.contents[i].classList.add('d-none')
        }
        // 
        this.contents[this.startIndex].classList.remove('d-none')
        this.contents[this.startIndex].classList.remove('opac-0')
        this.triggers[this.startIndex].classList.add('opac-50')
        this.triggers[this.startIndex].classList.add('b-custom-tab-active')

        this.triggersListenerClick()
    }

    triggersListenerClick() {
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].addEventListener('click', e => {
                let id = `#${e.currentTarget.getAttribute('data-custom-tab-trigger')}`
                this.triggersHandlerClick(id)
            })
        }
    }

    triggersHandlerClick(id) {
        // contents
        for (let i = 0; i < this.contents.length; i++) {
            this.contents[i].classList.add('opac-0')
            this.contents[i].classList.add('d-none')
        }
        document.querySelector(id).classList.remove('d-none')
        setTimeout(() => {
            document.querySelector(id).classList.remove('opac-0')
        }, 100)

        //triggers
        for (let i = 0; i < this.triggers.length; i++) {
            this.triggers[i].classList.remove('opac-50')
            this.triggers[i].classList.remove('b-custom-tab-active')
        }
        document.querySelector(`[data-custom-tab-trigger="${id.replace('#', '')}"]`).classList.add('opac-50')
        document.querySelector(`[data-custom-tab-trigger="${id.replace('#', '')}"]`).classList.add('b-custom-tab-active')
    }
}
let customTabsInit = () => {
    let allCustomTabsPlace = document.querySelectorAll('[data-custom-tab-place]')
    if (allCustomTabsPlace.length > 0) {
        for (let i = 0; i < allCustomTabsPlace.length; i++) {
            new CTab(allCustomTabsPlace[i])
        }
    }
}
customTabsInit()